import { render, staticRenderFns } from "./TypeApprover.vue?vue&type=template&id=864d82b6&scoped=true"
import script from "./TypeApprover.vue?vue&type=script&lang=js"
export * from "./TypeApprover.vue?vue&type=script&lang=js"
import style0 from "./TypeApprover.vue?vue&type=style&index=0&id=864d82b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864d82b6",
  null
  
)

export default component.exports